import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-385ea921"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "productTwo-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "com-bannerSwiperTwo-logo-div"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "com-bannerSwiperTwo-logo-com"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "com-bannerSwiperTwo-logo-img",
  alt: "",
  src: _imports_0
})])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_content_one = _resolveComponent("content-one");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_content_one), _hoisted_2]);
}